import React from "react";

function TermsOfUse() {
  return (
    <div className="landing-root">
      {/* Neon background */}
      <div className="background-particles" />

      <section className="landing-section glass-card">
        <h2 className="neon-title">Multiversal Blockchain Tracer</h2>
        <h2 className="neon-title">Terms of Use</h2>

        <p className="section-subtitle">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <h3>1. Purpose of the dApp</h3>
        <p>
          Multiversal Blockchain Tracer is a read-only blockchain analytics tool
          designed to display publicly available wallet balances, token data,
          and multi-chain activity for informational and educational purposes only.
        </p>

        <h3>2. No Financial Advice</h3>
        <p>
          Nothing displayed in this dApp constitutes financial, investment, or
          trading advice. Any analytics, insights, or AI-inspired scores are
          informational only and should not be relied upon for decision-making.
        </p>

        <h3>3. Public Blockchain Data</h3>
        <p>
          All wallet addresses, ENS names, balances, and token data shown are
          publicly available on their respective blockchains and retrieved via
          third-party data providers such as Covalent and CoinGecko.
        </p>

        <h3>4. Accuracy & Availability</h3>
        <p>
          While we strive for accuracy, blockchain data may be delayed,
          incomplete, or temporarily unavailable. We make no guarantees
          regarding accuracy, completeness, or uptime.
        </p>

        <h3>5. Acceptable Use</h3>
        <p>
          You agree not to misuse the dApp, attempt to disrupt service,
          reverse engineer systems, or use the platform for unlawful purposes.
        </p>

        <h3>6. Limitation of Liability</h3>
        <p>
          Use of this dApp is at your own risk. We are not liable for losses,
          damages, or decisions made based on information displayed by the dApp.
        </p>

        <h3>7. Changes to These Terms</h3>
        <p>
          These Terms may be updated from time to time. Continued use of the dApp
          constitutes acceptance of any changes.
        </p>

        <h3>8. Contact</h3>
        <p>
          For questions or concerns, please use the contact form available on the website.
        </p>
      </section>
    </div>
  );
}

export default TermsOfUse;
